const Builder = require('../BuilderBase');
const MenuDivider = require('../menuSelectors/MenuDivider');
const MenuItem = require('../menuSelectors/MenuItem');
const MenuShell = require('../menuSelectors/MenuShell');
const SubMenu = require('../menuSelectors/SubMenu');

module.exports = class Menu extends Builder {
    constructor(title, properties) {
        super('menu_Menu', title, properties);
    }

    menuDivider(title, properties) {
        let divider = new MenuDivider(title, properties);
        this.addChildBlock(divider);
        return divider;
    }

    menuItem(title, properties) {
        let item = new MenuItem(title, properties);
        this.addChildBlock(item);
        return item;
    }

    menuShell(title, properties) {
        let shell = new MenuShell(title, properties);
        this.addChildBlock(shell);
        return shell;
    }

    subMenu(title, properties) {
        let subMenu = new SubMenu(title, properties);
        this.addChildBlock(subMenu);
        return subMenu;
    }
};
